import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import ContactSection from '../../sections/ContactSection/ContactSection';
import { GlobalStyle } from '../../global/global';
import StyledButton from '../../components/Button/Button';
import {
    Box,
    Flex,
    Text,
    Image,
    Hide,
    Divider,
    List,
    SimpleGrid,
    ListItem,
    ListIcon,
    UnorderedList,
} from '@chakra-ui/react';
import { StyledHeading } from '../../sections/CalltoActionSection/styles';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';
import FormSection from '../../sections/FormSection/FormSection';
import Faq from '../../sections/Faq/Faq';
import { CheckIcon } from '@chakra-ui/icons';
import TableSection from '../../sections/TableSection/TableSection';

interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=315522&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - strona prac kontraktowych',
};

export default function ContractPage(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title={<>Ulepsz swój sklep i sprzedawaj jeszcze więcej</>}
                image={heroImage}
                // badgeLabel="SZABLON SKLEPU"
                subTitle="Zbadamy, przekształcimy, rozwiniemy i zmienimy twój sklep."
                buttons={[
                    {
                        title: 'Zamów prace kontraktowe',
                        href: '#',
                        variant: 'outline',
                    },
                ]}
            />
            {/*  */}
            <Flex
                className="homepage containerIdosellPages"
                direction={'column'}
                gap={{
                    base: 16,
                    md: 24,
                }}
                py={{
                    base: 16,
                    md: 24,
                }}
            >
                {/*  */}

                <Box pb={'6.25rem'}>
                    <FormSection
                        sectionTitle="Skontaktuj się
z ekspertem IdoSell i zamów prace kontraktowe"
                        sectionSubtitle="Skorzystaj z cyklicznych lub pojedynczych prac kontraktowych i czerp z wiedzy ekspertów.  sklep i sprzedawaj jeszcze więcej"
                        region="eu1"
                        portalId="26134891"
                        formId="b620a011-02e6-4a86-9eaf-a208c7507848"
                    />
                </Box>
                {/*  */}

                <SimpleGrid
                    templateColumns="repeat(2, 1fr)"
                    gap="30px"
                    gridTemplateColumns={{
                        sm: 'templateColumns="1fr"',
                        lg: 'repeat(2, 1fr)',
                    }}
                >
                    <Image
                        src={'https://www.idosell.com/panel/file-gate.php?id=290615&ext=.webp'}
                        my="auto"
                    />
                    <Box my="auto">
                        <Text
                            fontSize="34px"
                            lineHeight={'48px'}
                            fontWeight="bold"
                            className="text-wrapper-2"
                            color="#1AAC7A"
                            marginBottom={4}
                        >
                            Piękny sklep internetowy
                        </Text>
                        <List className="item-wrapper">
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Text
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Zmodyfikujemy szablon Twojego sklepu
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'25px'}>
                                        Modyfikujemy szablony od strony wizualnej. Dbamy również o
                                        aktualność szablonu pod kątem prawnym.
                                    </Text>
                                </Flex>
                            </ListItem>
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Box
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Wykonamy audyt UI
                                    </Box>
                                    <Box fontSize={'16px'} lineHeight={'25px'}>
                                        Przeprowadzimy audyt sklepu, który może być podstawą do
                                        dalszych prac na kontraktach z developerem.
                                    </Box>
                                </Flex>
                            </ListItem>
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Box
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Wykonamy prace graficzne
                                    </Box>
                                    <Box fontSize={'16px'} lineHeight={'25px'}>
                                        Stworzymy banery i inne treści wizualne na stronie.
                                    </Box>
                                </Flex>
                            </ListItem>
                        </List>
                    </Box>
                </SimpleGrid>
                <SimpleGrid
                    templateColumns="repeat(2, 1fr)"
                    gap="30px"
                    gridTemplateColumns={{
                        sm: 'templateColumns="1fr"',
                        lg: 'repeat(2, 1fr)',
                    }}
                >
                    <Box my="auto">
                        <Text
                            fontSize="34px"
                            lineHeight={'48px'}
                            fontWeight="bold"
                            className="text-wrapper-2"
                            color="#1AAC7A"
                            marginBottom={4}
                        >
                            Zawsze aktualny sklep internetowy
                        </Text>
                        <List className="item-wrapper">
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Text
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Zoptymalizujemy Twój sklep
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'25px'}>
                                        Optymalizujemy sklep pod kątem prędkości ładowania i
                                        technicznego SEO, zwiększając tym możliwości wzrostu
                                        organicznego pozycjonowania. Wprowadzamy sprawdzone
                                        rozwiązania, żeby sklep posiadał najnowsze mechanizmy
                                        sprzedażowe i techniczne.
                                    </Text>
                                </Flex>
                            </ListItem>
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Box
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Doradzimy i zoptymalizujemy konwersję
                                    </Box>
                                    <Box fontSize={'16px'} lineHeight={'25px'}>
                                        Sprawdzamy i proponujemy nowe rozwiązania w ramach testów
                                        A/B w sklepie, które mogą się przełożyć na zwiększenie
                                        sprzedaży bez dodatkowej inwestycji w marketing.
                                    </Box>
                                </Flex>
                            </ListItem>
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Box
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Zainstalujemy zewnętrze aplikacje
                                    </Box>
                                    <Box fontSize={'16px'} lineHeight={'25px'}>
                                        Wdrażamy zewnętrze aplikacje do sklepu (np. chatboty,
                                        zdjęcia 360, newslettery).
                                    </Box>
                                </Flex>
                            </ListItem>
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Box
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Zintegrujemy sklep z zewętrznymi usługami
                                    </Box>
                                    <Box fontSize={'16px'} lineHeight={'25px'}>
                                        Przygotowujemy specjalne pliki integracyjne (feedy) dla
                                        zewnętrznych porównywarek i serwisów.
                                    </Box>
                                </Flex>
                            </ListItem>
                        </List>
                    </Box>
                    <Image
                        src={'https://www.idosell.com/panel/file-gate.php?id=290615&ext=.webp'}
                        my="auto"
                    />
                </SimpleGrid>
                {/* */}
                <Divider borderColor="#C8C8C8" orientation="horizontal" />
                <Flex direction={'column'}>
                    <StyledHeading>Odkryj możliwości prac kontraktowych</StyledHeading>

                    <Flex
                        flexWrap={'wrap'}
                        // gap={{
                        //     base: 4,
                        //     lg: 0,
                        // }}
                        rowGap={{
                            base: 4,
                            md: 12,
                        }}
                        columnGap={{
                            base: 4,
                            lg: 1,
                        }}
                        mt={7}
                        justifyContent={'space-between'}
                    >
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Korzystaj z wiedzy ekspertów
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Nowoczesny, ekologiczny, a może klasyczny – twój sklep
                                    internetowy może wyglądać jak tylko zechcesz.
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Dowolnie zmieniaj wygląd sklepu
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Nowoczesny, ekologiczny, a może klasyczny – twój sklep
                                    internetowy może wyglądać jak tylko zechcesz.
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Zwiększ swoją konwersję
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Zoptymalizujemy wygląd i procesy na swojej stronie. Wiedza i
                                    doświadczenie ekspertów pomogą w stworzeniu sklepu, który
                                    sprzedaje więcej. Masz na to naszą gwarancję.
                                </Text>
                            </Box>
                        </Flex>
                    </Flex>
                </Flex>

                {/*  */}
                <Flex direction={'column'}>
                    <StyledHeading>Gwarancja bezpieczeństwa</StyledHeading>

                    <Flex
                        flexWrap={'wrap'}
                        // gap={{
                        //     base: 4,
                        //     lg: 0,
                        // }}
                        rowGap={{
                            base: 4,
                            md: 12,
                        }}
                        columnGap={{
                            base: 4,
                            lg: 1,
                        }}
                        mt={7}
                        justifyContent={'space-between'}
                    >
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Eksperci IdoSell
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Prace kontraktowe wykonują doświadczeni specjaliści UI z zespołu
                                    UXD oraz Web Developerzy, czyli specjaliści z zakresu
                                    programowania, technicznego SEO oraz optymalizacji konwersji.
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Doradca przypisany do Twojego sklepu
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Podczas cyklicznych prac kontraktowych będziesz współpracował z
                                    jednym developerem w ramach dnia kontraktowego.
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    60 dni gwarancji
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    W przypadku niezadowolenia z efektów prac kontraktowych,
                                    zapewniamy 60-dniowy okres gwarancji, podczas którego nasi
                                    specjaliści wprowadzą zmiany (...)
                                </Text>
                            </Box>
                        </Flex>
                    </Flex>
                </Flex>

                {/*  */}
                <TableSection
                    title="Prace kontraktowe - cykliczne czy pojedyncze?"
                    valuesName={{
                        CYCLIC: 'Prace cykliczne',
                        ONETIME: 'Prace pojedyncze',
                    }}
                    mainCategories={{
                        DLA_KOGO: 'Informacje podstawowe',
                        CO_ZAWIERA: 'Szczegóły',
                        INFORMACJE_SZCZEGOLOWE: 'Dla kogo wybrany tryb pracy?',
                    }}
                    tableSection={[
                        {
                            category: 'Informacje podstawowe',
                            name: 'Cena prac kontaktowych',
                            values: {
                                CYCLIC: (
                                    <Text
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight={'700'}
                                    >
                                        2 x 1200 zł netto
                                    </Text>
                                ),
                                ONETIME: (
                                    <Text
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight={'700'}
                                    >
                                        1500 zł netto
                                    </Text>
                                ),
                            },
                        },
                        {
                            category: 'Informacje podstawowe',
                            name: 'Minimalny czas kontraktacji',
                            values: {
                                CYCLIC: (
                                    <Text
                                        fontSize={'12px'}
                                        lineHeight={'19px'}
                                        fontWeight={'400'}
                                        textAlign={'center'}
                                    >
                                        2 dni (w ciągu 2 miesięcy)
                                    </Text>
                                ),
                                ONETIME: (
                                    <Text
                                        fontSize={'12px'}
                                        lineHeight={'19px'}
                                        fontWeight={'400'}
                                        textAlign={'center'}
                                    >
                                        1 dzień
                                    </Text>
                                ),
                            },
                        },
                        {
                            category: 'Szczegóły',
                            name: 'Kiedy się odbywają?',
                            values: {
                                CYCLIC: (
                                    <Text
                                        fontSize={'12px'}
                                        lineHeight={'19px'}
                                        fontWeight={'400'}
                                        textAlign={'center'}
                                    >
                                        Stałe terminy ustalone z góry{' '}
                                        <Text>(dzień tygodnia i godzina startu)</Text>
                                    </Text>
                                ),
                                ONETIME: (
                                    <Text
                                        fontSize={'12px'}
                                        lineHeight={'19px'}
                                        fontWeight={'400'}
                                        textAlign={'center'}
                                    >
                                        Ustalany w momencie zamówienia{' '}
                                        <Text>(dzień miesiąca i godzina startu)</Text>
                                    </Text>
                                ),
                            },
                        },
                        {
                            category: 'Szczegóły',
                            name: 'Okres trwania',
                            values: {
                                CYCLIC: (
                                    <Text
                                        fontSize={'12px'}
                                        lineHeight={'19px'}
                                        fontWeight={'400'}
                                        textAlign={'center'}
                                    >
                                        Zamawiane na czas nieokreślony z możliwością wypowiedzenia
                                        na 1 miesiąc przed zakończeniem
                                    </Text>
                                ),
                                ONETIME: (
                                    <Text
                                        fontSize={'12px'}
                                        lineHeight={'19px'}
                                        fontWeight={'400'}
                                        textAlign={'center'}
                                    >
                                        Tylko w wykupionym dniu lub dniach
                                        <Text>(nie ma okresu wypowiedzenia)</Text>
                                    </Text>
                                ),
                            },
                        },
                        {
                            category: 'Szczegóły',
                            name: 'Współpraca z ekspertem',
                            values: {
                                CYCLIC: (
                                    <Text
                                        fontSize={'12px'}
                                        lineHeight={'19px'}
                                        fontWeight={'400'}
                                        textAlign={'center'}
                                    >
                                        Stały developer
                                    </Text>
                                ),
                                ONETIME: (
                                    <Text
                                        fontSize={'12px'}
                                        lineHeight={'19px'}
                                        fontWeight={'400'}
                                        textAlign={'center'}
                                    >
                                        Tylko w wykupionym dniu lub dniach
                                        <Text>(nie ma okresu wypowiedzenia)</Text>
                                    </Text>
                                ),
                            },
                        },
                        {
                            category: 'Dla kogo wybrany tryb pracy?',
                            name: '',
                            values: {
                                CYCLIC: (
                                    <UnorderedList>
                                        <ListItem mb={'15px'}>
                                            Dla klientów, którzy chcą rozwijać swój sklep w celu
                                            zwiększenia konwersji i trudno oszacować ile pracy na to
                                            potrzeba,
                                        </ListItem>
                                        <ListItem mb={'15px'}>
                                            Dla większych projektów indywidualnych
                                        </ListItem>
                                        <ListItem mb={'15px'}>
                                            Dla tych, którzy chcą posiadać stałego opiekuna, który
                                            dobrze zna sklep i potrzeby klienta
                                        </ListItem>
                                        <ListItem mb={'15px'}>
                                            Dla tych, którzy chcą mieć przewidywalny czas reakcji na
                                            zamówione zmiany
                                        </ListItem>
                                    </UnorderedList>
                                ),
                                ONETIME: (
                                    <UnorderedList>
                                        <ListItem mb={'15px'}>
                                            Dla sklepów, które nie potrzebują stałego wsparcia,
                                        </ListItem>
                                        <ListItem mb={'15px'}>
                                            Dla niekrytycznych zmian, gdy brak gwarantowanego
                                            follow-up nie jest krytycznie ważny,
                                        </ListItem>
                                        <ListItem mb={'15px'}>
                                            Dla zmian, których oszacowanie czasochłonności jest
                                            możliwe z małym ryzykiem
                                        </ListItem>
                                    </UnorderedList>
                                ),
                            },
                        },
                    ]}
                    tableColumns={2}
                    isOpenAll={true}
                    isBlocked={{ md: true }}
                />
                {/* <Box id="modern-financing" pt={5}>
                    <SectionWithPlusTick
                        alignItems={'center'}
                        display={'flex'}
                        flexDirection={'column'}
                        background={'#1AAC7A'}
                        ctaButton={{
                            label: 'Zyskaj środki',
                            href: 'https://wealthon.com/',
                        }}
                        image={{
                            url: 'https://www.idosell.com/panel/file-gate.php?id=314190&ext=.webp',

                            alt: 'Zdjęcie Pani z założonymi rękami',
                        }}
                        tickItem={[
                            {
                                title: 'Wszystkie formalności załatwisz online ',
                            },
                            {
                                title: 'Eksperci Wealthon są do stałej dyspozycji i pomocy',
                            },
                            {
                                title: 'Wypłata pożyczki nastąpi w ciągu 24 godzin',
                            },
                        ]}
                    />
                </Box> */}
                {/*  */}
                <Box
                    padding={'6.25rem 0'}
                    position={'relative'}
                    _before={{
                        content: '""',
                        position: 'absolute',
                        height: '100%',
                        top: 0,
                        width: '100vw',
                        marginLeft: '50%',
                        left: '-50vw',
                        zIndex: -2,
                        backgroundColor: '#EEEEEE',
                    }}
                >
                    <Faq
                        title="Najczęściej zadawane pytania"
                        list={[
                            {
                                question:
                                    'Czy przelewy realizowane przez IdoPay w systemie PayByLink są bezpieczne dla mnie i moich klientów?',
                                anwser: (
                                    <>
                                        <Text>
                                            Czy przelewy realizowane przez IdoPay w systemie
                                            PayByLink są bezpieczne dla mnie i moich klientów?
                                        </Text>
                                    </>
                                ),
                            },
                            {
                                question:
                                    'Czy przelewy realizowane przez IdoPay w systemie PayByLink są bezpieczne dla mnie i moich klientów?',
                                anwser: (
                                    <>
                                        <Text>
                                            Czy przelewy realizowane przez IdoPay w systemie
                                            PayByLink są bezpieczne dla mnie i moich klientów?
                                        </Text>
                                    </>
                                ),
                            },
                            {
                                question:
                                    'Czy przelewy realizowane przez IdoPay w systemie PayByLink są bezpieczne dla mnie i moich klientów?',
                                anwser: (
                                    <>
                                        <Text>
                                            Czy przelewy realizowane przez IdoPay w systemie
                                            PayByLink są bezpieczne dla mnie i moich klientów?
                                        </Text>
                                    </>
                                ),
                            },
                            {
                                question:
                                    'Czy przelewy realizowane przez IdoPay w systemie PayByLink są bezpieczne dla mnie i moich klientów?',
                                anwser: (
                                    <>
                                        <Text>
                                            Czy przelewy realizowane przez IdoPay w systemie
                                            PayByLink są bezpieczne dla mnie i moich klientów?
                                        </Text>
                                    </>
                                ),
                            },
                            {
                                question:
                                    'Czy przelewy realizowane przez IdoPay w systemie PayByLink są bezpieczne dla mnie i moich klientów?',
                                anwser: (
                                    <>
                                        <Text>
                                            Czy przelewy realizowane przez IdoPay w systemie
                                            PayByLink są bezpieczne dla mnie i moich klientów?
                                        </Text>
                                    </>
                                ),
                            },
                        ]}
                    />
                </Box>
                <ContactSection />
            </Flex>
        </ThemeProvider>
    );
}
